<template>
	<div>
		<AppButton
			:label="$t('add-company')"
			startIcon="assets/v2/image/icons/plus.svg"
			@click="openAddCompanyDialog"
		/>
	</div>
</template>

<script setup>
import { useShippingCompaniesDialogStore } from '../../../stores/shipping-companies-dialog';

const shippingCompaniesDialogStore = useShippingCompaniesDialogStore();

const openAddCompanyDialog = () => {
	shippingCompaniesDialogStore.openDialog();
};
</script>

<style lang="scss" scoped></style>
